VjsAdmin.DistrictSettings = (function () {
    const me = {};

    me.$settings_table = $('#settings-table');

    me.platform_id = me.$settings_table.attr('data-platform-id');
    me.district_joint_guid = me.$settings_table.attr('data-district-joint-guid');

    me.init = function () {
        const url = Slim.Router.pathFor('platforms.districts.settings.list.json', {
            platform_id: me.platform_id,
            district_joint_guid: me.district_joint_guid,
        });

        $('#ajax-progress-indicator').show();
        $.get(url, {}, (d) => {
            const { data } = d;
            $('#password_policy_admin').val(data.password_policy_admin);
            $('#password_length_admin').val(data.password_length_admin);
            $('#password_policy_user').val(data.password_policy_user);
            $('#password_length_user').val(data.password_length_user);
            $('#ajax-progress-indicator').hide();
        });

        $('#settings-passwords-form').submit(() => {
            const data = {};
            data.password_policy_admin = $('#password_policy_admin').val();
            data.password_length_admin = $('#password_length_admin').val();
            data.password_policy_user = $('#password_policy_user').val();
            data.password_length_user = $('#password_length_user').val();

            $.ajax({
                url: Slim.Router.pathFor('platforms.districts.settings.update', {
                    platform_id: me.platform_id,
                    district_joint_guid: me.district_joint_guid,
                }),
                type: 'put',
                data,
                success() {
                    window.location.reload();
                },
            });

            return false;
        });
    };

    return {
        init: me.init,
    };
}());
